import { EnumInit } from "@/api/all"
import { getServiceArea, setServiceArea, getServicePlatform, setServicePlatform } from "@/utils/storages"
import { getCurrentUserAreas } from "@/api/system/user"

const webSite = {
  state: {
    enumConfigs: {},
    serviceArea: getServiceArea(),
    serviceAreas: [],
    servicePlatform: getServicePlatform()
  },
  mutations: {
    setEnumConfigs(state, enums) {
      state.enumConfigs = enums
    },
    setServiceArea(state, area) {
      state.serviceArea = area
    },
    setServiceAreas(state, areas) {
      state.serviceAreas = areas
    },
    setServicePlatform(state, platform) {
      state.servicePlatform = platform
    }
  },
  actions: {
    setEnumConfigs({ commit }) {
      return new Promise((resolve, reject) => {
        EnumInit().then(res => {
          commit('setEnumConfigs', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setServiceArea({ commit }, val) {
      commit("setServiceArea", val)
      setServiceArea(val)
    },
    setServiceAreas({ commit }) {
      return new Promise((resolve, reject) => {
        getCurrentUserAreas().then(res => {
          commit('setServiceAreas', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setServicePlatform({ commit }, val) {
      commit("setServicePlatform", val)
      setServicePlatform(val)
    }
  }
}
export default webSite

